import { computed, defineComponent, inject, reactive, type PropType } from 'vue'
import { BdDialog } from '-/Base/BdDialog'
import { Alert, Checkbox, Tooltip, Button } from 'ant-design-vue'
import { FilterFilled, HolderOutlined } from '@ant-design/icons-vue'
import { VueDraggableNext as Draggable } from 'vue-draggable-next'
import type { IConfig } from '../../types'
import styles from '../headerBtn.module.less'
import alertStyles from './index.module.less'

export default defineComponent({
  name: 'CustomTableHeader',
  props: {
    checks: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    columns: {
      type: Array as PropType<IConfig['columns']>,
      default: () => []
    }
  },
  emits: ['update:columns', 'update:checks', 'reset'],
  setup(props, { emit }) {
    const columnsKey = inject('columnsKey') as string
    const checksKey = inject('checksKey') as string
    const state = reactive({
      dialogVisible: false,
      status: !!window.localStorage.getItem(columnsKey) || !!window.localStorage.getItem(checksKey)
    })
    const _columns = computed<any[]>({
      get() {
        return props.columns
      },
      set(nval) {
        emit('update:columns', nval)
        state.status = true
        window.localStorage.setItem(columnsKey, JSON.stringify(nval))
      }
    })
    const checksTmp = computed({
      get() {
        return props.checks
      },
      set(nval) {
        emit('update:checks', nval)
        state.status = true
        window.localStorage.setItem(checksKey, JSON.stringify(nval))
      }
    })
    return () => (
      <>
        <Tooltip title='自定义列' placement='top'>
          <div class={[styles.btn, `${state.status ? styles.btnActive : ''}`]} onClick={() => (state.dialogVisible = true)}>
            <FilterFilled />
          </div>
        </Tooltip>
        <BdDialog v-model={[state.dialogVisible, 'visible']} title='自定义列' footer={null}>
          <Alert
            showIcon
            message={
              <div class={alertStyles.alert}>
                <span>拖动可对表格列排序</span>
                <Button
                  type='link'
                  size='small'
                  disabled={!state.status}
                  onClick={() => {
                    emit('reset')
                    state.status = false
                  }}
                >
                  恢复默认
                </Button>
              </div>
            }
          />
          <Checkbox.Group v-model={[checksTmp.value, 'value']} style='width:100%;margin-top:20px'>
            <Draggable
              v-model={[_columns.value, 'modelValue']}
              class={styles.checkbox}
              {...{ animation: 500, dragClass: 'draggable--draging', ghostClass: 'draggable--ghost', handle: '.anticon' }}
            >
              {_columns.value.map(item => (
                <Checkbox value={item.dataIndex} key={item.dataIndex}>
                  <div> {item.titleText} </div>
                  <HolderOutlined />
                </Checkbox>
              ))}
            </Draggable>
          </Checkbox.Group>
        </BdDialog>
      </>
    )
  }
})
